import React from 'react';
import {GetTheme} from 'mgUiKit';
import PropTypes from 'prop-types';

export default class Theme extends React.Component{
    constructor(props, context){
        super(props);
    }

    render(){
        return this.props.children;
    }

     getChildContext() {
        return {
            theme: this.props.theme
        };
    }

}

Theme.displayName = "ThemeComponent";

// PropTypes validation
Theme.propTypes = {
    theme: PropTypes.object.isRequired
};

// default props
Theme.defaultProps = {
};

// Definizione
Theme.childContextTypes = {
    theme: PropTypes.object
}